import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { FleaMarketsRolloutConfig } from '@/types/fleaMarkets';

const DEFAULT_CONFIG: FleaMarketsRolloutConfig = {
  enabled: true,
  host_edit_enabled: true,
  public_visibility_enabled: true,
};

export function useFleaMarketRollout() {
  const query = useQuery({
    queryKey: ['flea-markets-rollout'],
    queryFn: async (): Promise<FleaMarketsRolloutConfig> => {
      const { data, error } = await supabase.rpc('get_feature_rollout_config' as any, {
        p_key: 'flea_markets',
        p_default: DEFAULT_CONFIG as any,
      } as any);

      if (error) {
        if (import.meta.env.DEV) {
          console.warn('[useFleaMarketRollout] fallback due to RPC error:', error.message);
        }
        return DEFAULT_CONFIG;
      }

      const row = (data ?? {}) as Partial<FleaMarketsRolloutConfig>;
      return {
        enabled: row.enabled ?? DEFAULT_CONFIG.enabled,
        host_edit_enabled: row.host_edit_enabled ?? DEFAULT_CONFIG.host_edit_enabled,
        public_visibility_enabled: row.public_visibility_enabled ?? DEFAULT_CONFIG.public_visibility_enabled,
      };
    },
    staleTime: 60_000,
  });

  return {
    config: query.data ?? DEFAULT_CONFIG,
    isLoading: query.isLoading,
    error: query.error,
  };
}
